import { useEffect, useState } from "react";

export default function SearchBar({ data, field, setData }) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (query !== "") {
      const filteredData = data.filter((x) =>
        x[field].toLowerCase().includes(query.toLowerCase())
      );
      setData(filteredData);
    } else {
      setData(data);
    }
  }, [query, data, setData, field]);
  
  return (
    <div>
      <input
        type="text"
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </div>
  );
}
